import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import {
    ARRAY_TYPE_ACCOUNT,
    ROLE_DIRECTOR,
    SALE_INTERN,
    SALE_LEADER,
    SALE_MEMBER,
    TARGET_PERSONAL, TARGET_TEAM
} from "../../config/accountTypeOption";
import {TINH, TRUNG_TAM} from "../../config/area";
import {isPilotEntrance as isPilotEntranceCenter} from "../../config/center/centerOption";
import {JUNIOR} from "@/core/config/businessLevel";
// action types
export const VERIFY_AUTH = "verifyAuth";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_PASSWORD = "updateUser";
export const FORGOT_PASSWORD = "forgot-password";
export const RESET_PASSWORD = "reset_password";
export const FACEBOOK_LOGIN = "facebook_login";
export const GOOGLE_LOGIN = "google_login";
export const ADN_OAUTH_AUTHORIZE = "adn_oauth_authorize";
export const OAUTH_AUTHORIZE = "oauth_authorize";

// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_PASSWORD = "setPassword";
export const SET_ERROR = "setError";
const state = {
    errors: null,
    user: JSON.parse(localStorage.getItem(`user`)) || {},
    isAuthenticated: !!JwtService.getToken(),
};

const getters = {
    currentUser(state) {
        return state.user;
    },
    isAuthenticated(state) {
        return state.isAuthenticated;
    },
    isPilot(state){
        return true
    },
    isPilotEntrance(state) {
        return isPilotEntranceCenter(state.user?.profile?.branch?.id);
    },
    keyAccount() {
        let keyId = state.user.account_type.id ?? 0;
        let business_level_id = state.user.profile.business_level_id
        let keyBusiness = [14, 18].includes(business_level_id) ? business_level_id : 0;
        const finalKey = `${keyId}${keyBusiness}`;
        return ARRAY_TYPE_ACCOUNT[finalKey] ?? ROLE_DIRECTOR;
    },
    isActiveManager(state) {
        return [7].includes(getters.keyAccount()) || [295391, 266029].includes(state.user.id)
    },
    isActiveSale(state) {
        return [1,2,3,4,5,6].includes(getters.keyAccount())
    },
    isDoubleView() {
        return [7].includes(getters.keyAccount())
    },
    isActiveGoal() {
        return [1,2,3,5,6,7].includes(getters.keyAccount())
    },
    isShowMonthDash() {
        return [1,2,3,4,5,6,7].includes(getters.keyAccount())
    },
    isBOD() {
        return [7].includes(getters.keyAccount()) || [295391, 266029].includes(state.user.id)
    },
    targetPersonal() {
        let businessLevelIndex = state.user && state.user.profile && state.user.profile.business_level ? state.user.profile.business_level.index : '';
        let salaryMechanismId = state.user ? state.user.profile.salary_mechanism_id : '';
        let area_type_id = state.user && state.user.profile && state.user.profile.branch && state.user.profile.branch.area ? state.user.profile.branch.area.type_id : '';
        let account_type_id = state.user && state.user.profile ? state.user.profile.account_type_id : '';
        if (account_type_id === SALE_INTERN) {
            businessLevelIndex = JUNIOR; // Nếu là SI thì sẽ giống Sale Member JUNIOR
        }
        if ((!area_type_id || !businessLevelIndex) && account_type_id !== SALE_INTERN) {
            return;
        }
        if (area_type_id === TRUNG_TAM) {
            return TARGET_PERSONAL[TRUNG_TAM][businessLevelIndex];
        }
        return TARGET_PERSONAL[TINH][salaryMechanismId][businessLevelIndex];
    },
    targetTeam() {
        let area_type_id = state.user && state.user.profile && state.user.profile.branch && state.user.profile.branch.area ? state.user.profile.branch.area.type_id : '';
        let businessLevelIndex = state.user && state.user.profile && state.user.profile.business_level ? state.user.profile.business_level.index : '';
        if (area_type_id === TRUNG_TAM) {
            return TARGET_TEAM[TRUNG_TAM][businessLevelIndex];
        } else {
            return TARGET_TEAM[TINH][businessLevelIndex];
        }
    },
};



const actions = {
    [LOGIN](context, credentials) {
        return new Promise((resolve, reject) => {
            ApiService.post("/login", credentials).then(({data}) => {
                context.commit(SET_AUTH, data.user);
                const token =
                    data.auth_tokennoibo
                    || data.data?.auth_tokennoibo
                    || data.token
                    || data.data?.token;
                if (token) {
                    JwtService.saveToken(token);
                }
                resolve(data);
            }).catch(({response}) => {
                context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                reject(response)
            });
        });
    },
    [FACEBOOK_LOGIN](context, credentials) {
        return new Promise(resolve => {
            ApiService.post("/login/facebook", credentials).then(({data}) => {
                context.commit(SET_AUTH, data.user);
                resolve(data);
            }).catch(({response}) => {
                context.commit(SET_ERROR, response && response.data ? response.data.message : '');
            });
        });
    },
    [GOOGLE_LOGIN](context, credentials) {
        return new Promise(resolve => {
            ApiService.post("/login/google", credentials).then(({data}) => {
                context.commit(SET_AUTH, data.user);
                resolve(data);
            }).catch(({response}) => {
                context.commit(SET_ERROR, response && response.data ? response.data.message : '');
            });
        });
    },
    [LOGOUT](context) {
        return new Promise((resolve, reject) => {
            ApiService.post('logout')
                .then(({data}) => {
                    context.commit(PURGE_AUTH);
                    localStorage.removeItem('user');
                    resolve(data)
                })
                .catch(({response}) => {
                    context.commit(SET_ERROR, response && response.data ? response.data.errors : '');
                    reject(response)
                });
        })

    },
    [REGISTER](context, credentials) {
        return new Promise((resolve, reject) => {
            ApiService.post("register", credentials)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [FORGOT_PASSWORD](context, credentials) {
        return new Promise((resolve, reject) => {
            ApiService.post("forgot-password", credentials)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [RESET_PASSWORD](context, credentials) {
        return new Promise((resolve, reject) => {
            ApiService.post("password-reset", credentials)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [VERIFY_AUTH](context) {
        if (JwtService.getToken()) {
            // ApiService.setHeader();
            // ApiService.post('verify')
            //   .then(({ data }) => {
            //     context.commit(SET_AUTH, data);
            //   })
            //   .catch(({ response }) => {
            //     context.commit(SET_ERROR, response && response.data ? response.data.errors : '');
            //   });
        } else {
            context.commit(PURGE_AUTH);
        }
    },
    [UPDATE_PASSWORD](context, payload) {
        return new Promise(resolve => {
            ApiService.post("/change-password", payload)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    if (response?.data?.data?.message_validate_form) {
                        context.commit(SET_ERROR, response.data.data.message_validate_form);
                    } else {
                        context.commit(SET_ERROR, response && response.data ? response.data.message : '');
                    }
                });
        });
    },
    [ADN_OAUTH_AUTHORIZE](context, credentials) {
        return new Promise((resolve, reject) => {
            ApiService.post("adn/oauth/authorize", credentials)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    },
    [OAUTH_AUTHORIZE](context, credentials) {
        return new Promise((resolve, reject) => {
            ApiService.post("oauth/authorize", credentials)
                .then(({data}) => {
                    resolve(data);
                })
                .catch(({response}) => {
                    reject(response);
                });
        });
    }
};

const mutations = {
    [SET_ERROR](state, error) {
        state.errors = error;
    },
    [SET_AUTH](state, user) {
        state.isAuthenticated = true;
        state.user = user;
        localStorage.setItem('user', JSON.stringify(user));
        state.errors = {};
        JwtService.saveToken('Edutalk');
    },
    [SET_PASSWORD](state, password) {
        state.user.password = password;
    },
    [PURGE_AUTH](state) {
        JwtService.saveToken('Edutalk');
        state.isAuthenticated = false;
        state.user = {};
        state.errors = {};
        state.isWaitUsers = 0;
        localStorage.removeItem('isWaitUsers');
        JwtService.destroyToken();
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
